// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Menu from './Menu';

import helpers from '../util/helpers';

type Props = {

}

type State = {
  menuopen: boolean
}

class MenuButton extends Component<Props, State> {
  constructor() {
    super();
    this.state = { menuopen: false };
  }

  toggleMenu(): void {
    if(this.state.menuopen) {
      this.setState({ menuopen: false });
      document.getElementsByTagName("body")[0].style.overflow = "visible";
    }
    else {
      helpers.eventLog("modal - menuopen");
      this.setState({ menuopen: true });
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
    }
  }

  linkClicked(): void {
    this.setState({ menuopen: false });
    // NO do this in Menu.js -- helpers.eventLog("nav:menu button pressed -  - " + this.props.to);
    document.getElementsByTagName("body")[0].style.overflow = "visible";
  }

  render() {
    const menu = this.state.menuopen ? (<Menu linkClicked={this.linkClicked.bind(this)} appState={this.props.appState} />) : '';

    // <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z" fill="rgba(255,255,255,1)"/></svg>
    const hamburgerIcon = (<svg className="hamburgerIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 4h25v3H3V4zm0 8h25v3H3v-2zm0 8h25v3H3v-2z" fill="rgba(255,255,255,1)"/></svg>)
    return (
      <div className='menu-button printhide'>
        <span className='menu-button-span' onClick={this.toggleMenu.bind(this)}>
          {hamburgerIcon}
        </span>
        {menu}
      </div>
    );
  }
}

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/MenuButton.js